import React from "react";
import ChooseUS from "../../common/images/choose-us.png";
export default function WhyChooseUs() {
  return (
    <div
      className="bg-contain bg-center "
      style={{ backgroundImage: "url('/android-dot.png')" }}
    >
      <section className="max-w-[1280px] mx-auto px-6 py-10 ">
        <div className="text-center mb-5">
          <h2 className="small:text-4xl text-3xl font-bold md:text-5xl">
            Why Choose Us?
          </h2>
          <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
            <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
          </div>
        </div>
        <div className="md:flex md:items-center md:justify-between">
          <div className="md:w-1/2">
            <p className="text-gray-700 leading-relaxed">
              At Binary Ops Pvt Ltd, we specialize in both{" "}
              <strong>front-end</strong> and <strong>back-end</strong>{" "}
              development to deliver a smooth and fast user experience. Our team
              focuses on security, scalability, and performance to ensure your
              website or application runs flawlessly. We prioritize secure data
              handling and efficient coding practices, allowing your business to
              grow without technical limitations.
              With a focus on user-friendly design and fast load times, we help your business thrive online while providing ongoing support to keep things running smoothly.
            </p>
            <p className="text-gray-700 mt-4 leading-relaxed">
              We stay updated with the latest industry trends to implement
              modern solutions that drive results. Our collaborative approach
              ensures that your vision is at the heart of every project. Whether
              you're launching a new platform or improving an existing one,
              we're here to help you succeed.
            </p>
          </div>

          {/* Image Section */}
          <div className="md:w-1/2 flex justify-center mt-6 md:mt-0">
            <img
              src={ChooseUS}
              alt="Why Choose Us"
              className="w-full md:w-[70%] mx-auto"
            />
          </div>
        </div>
      </section>
      
    </div>
  );
}
